import React, { useEffect } from 'react';
import { useFormContext } from 'ui-builder';
import { InformationMessage } from 'features/nekst-widgets';

import styles from './AiAnalysisLoaderWidget.module.scss';

const LOADER_MESSAGES = [
  'Using AI to extract Key Dates',
  'Pulling Transaction Party Information',
  'Linking To Detail Boxes',
];

export function AiAnalysisLoaderWidget() {
  const formContext = useFormContext();

  const [isVisible, setIsVisible] = React.useState(false);
  const [messageIndex, setMessageIndex] = React.useState(0);
  const [numberOfDots, setNumberOfDots] = React.useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setMessageIndex((prev) => {
        if (prev < LOADER_MESSAGES.length - 1) {
          return prev + 1;
        } else {
          return prev;
        }
      });
    }, 15 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (formContext.loading) {
      const timeoutId = setTimeout(() => {
        setIsVisible(true);
      }, 200);
      return () => clearTimeout(timeoutId);
    } else {
      setIsVisible(false);
    }
    return undefined;
  }, [formContext.loading]);

  useEffect(() => {
    const interval = setInterval(() => {
      setNumberOfDots((prev) => {
        if (prev < 3) {
          return prev + 1;
        } else {
          return 1;
        }
      });
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  if (isVisible) {
    return (
      <InformationMessage>
        The document is being processed. This may take 1-2 minutes. Please wait and do not refresh
        the page.
        <br />
        <br />
        <span className={styles.message}>{LOADER_MESSAGES[messageIndex]}{Array(numberOfDots)
          .fill('.')
          .join('')}</span>
      </InformationMessage>
    );
  } else {
    return null;
  }
}
